import { PayloadAction } from '@reduxjs/toolkit';
import { AnnotationsState } from '@reducers/v2/annotationsV2/annotationsV2.slice';

export const clearAnnotationsForPageAction = (
  state: AnnotationsState,
  action: PayloadAction<{ documentId: number; pageNumber: number }>
) => {
  const { documentId, pageNumber } = action.payload;
  if (state.byDocument[documentId]) {
    delete state.byDocument[documentId][pageNumber];
  }
};
